/**
 * Códigos de permiso tipo ACCIÓN alineados al plan de autorización / seeds backend.
 * Los de menú (`menu.*`) siguen en `nav-item.model.ts` (`NAV_ITEMS`).
 */
export const PERMISO_ACCION = {
  archivo: {
    consultar: 'archivo.consultar',
    crear: 'archivo.crear',
    actualizar: 'archivo.actualizar',
    anular: 'archivo.anular',
    descargar: 'archivo.descargar',
    reprocesar: 'archivo.reprocesar',
  },
  catalogo: {
    consultar: 'catalogo.consultar',
    crear: 'catalogo.crear',
    editar: 'catalogo.editar',
  },
  motor: {
    consultar: 'motor.consultar',
    editar: 'motor.editar',
    ejecutar: 'motor.ejecutar',
  },
  confirmacion: {
    consultar: 'confirmacion.consultar',
    confirmar: 'confirmacion.confirmar',
  },
  matriz: {
    consultar: 'matriz.consultar',
    cargar: 'matriz.cargar',
    editarReglas: 'matriz.editar-reglas',
  },
  auditoria: {
    consultar: 'auditoria.consultar',
    exportar: 'auditoria.exportar',
  },
  dashboard: {
    consultar: 'dashboard.consultar',
  },
} as const;

/** Lista plana de códigos ACCIÓN para seeds, docs o validaciones. */
export const PERMISO_ACCION_CODIGOS: readonly string[] = [
  PERMISO_ACCION.archivo.consultar,
  PERMISO_ACCION.archivo.crear,
  PERMISO_ACCION.archivo.actualizar,
  PERMISO_ACCION.archivo.anular,
  PERMISO_ACCION.archivo.descargar,
  PERMISO_ACCION.archivo.reprocesar,
  PERMISO_ACCION.catalogo.consultar,
  PERMISO_ACCION.catalogo.crear,
  PERMISO_ACCION.catalogo.editar,
  PERMISO_ACCION.motor.consultar,
  PERMISO_ACCION.motor.editar,
  PERMISO_ACCION.motor.ejecutar,
  PERMISO_ACCION.confirmacion.consultar,
  PERMISO_ACCION.confirmacion.confirmar,
  PERMISO_ACCION.matriz.consultar,
  PERMISO_ACCION.matriz.cargar,
  PERMISO_ACCION.matriz.editarReglas,
  PERMISO_ACCION.auditoria.consultar,
  PERMISO_ACCION.auditoria.exportar,
  PERMISO_ACCION.dashboard.consultar,
];
